<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <JssRichText class="platform-title" :field="fields?.title" tag="h2" />
      <div class="platform-content">
        <div class="platform-card">
          <JssRichText class="platform-card-title" :field="fields?.cardTitle" />
          <AdaptiveImage
            class="platform-card-stepImage"
            :field="fields?.stepImage"
            :isBackground="false"
            :lazy-load="false"
            :enableScrollDetection="false"
            :show="true"
          />
          <div class="platform-card-desc" v-if="fields?.stepDescList?.length > 0">
            <div
              class="platform-card-desc-item"
              v-for="item in fields?.stepDescList"
              :key="item?.id"
            >
              <JssRichText :field="item?.fields?.desc" />
            </div>
          </div>
          <div class="platform-card-tag" v-if="fields?.iconList?.length > 0">
            <div class="platform-card-tag-item" v-for="item in fields?.iconList" :key="item?.id">
              <div class="platform-card-tag-item-icon">
                <Icon :field="item?.fields?.icon" />
              </div>
              <JssRichText class="platform-card-tag-item-text" :field="item?.fields?.text" />
            </div>
          </div>
        </div>
        <div class="platform-tag" v-if="fields?.footerList?.length > 0">
          <div class="platform-tag-item" v-for="item in fields?.footerList" :key="item?.id">
            <JssRichText class="platform-tag-item-title" :field="item?.fields?.title" />
            <JssRichText class="platform-tag-item-desc" :field="item?.fields?.desc" />
          </div>
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed } from 'vue';
import utils from '@/utils';

export default {
  name: 'Platform',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  setup(props) {
    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'platform'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    return {
      rootClass,
      rootStyle,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.platform {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-title {
    text-align: center;
  }

  &-content {
    width: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &-card {
    width: 1135px;
    margin-top: 24px;
    padding: 24px;
    border: 1px solid $blue-night;
    border-radius: 24px;
    background-color: #f6faf9;

    &-stepImage {
      margin-top: 24px;
    }

    &-title {
      font-size: 32px;
      font-weight: 700;
      line-height: 1.4;
      color: $blue-night;
      text-align: center;
    }

    &-desc {
      margin-top: 24px;
      display: flex;
      gap: 8px;

      &-item {
        height: 54px;
        font-size: 16px;
        color: $grey-black;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #c7d3c7;
        text-align: center;
        border-radius: 4px;

        &:nth-child(1) {
          flex: 1;
        }

        &:nth-child(2) {
          flex: 2.1;
        }

        &:nth-child(3) {
          flex: 1;
        }

        &:nth-child(4) {
          flex: 0.65;
        }
      }
    }

    &-tag {
      width: 100%;
      display: flex;
      gap: 24px;
      border: 1px solid #abbcac;
      border-radius: 100px;
      padding: 16px 32px;
      margin-top: 24px;

      &-item {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-size: 14px;
        color: #0f172b;

        &-icon {
          width: 32px;
          height: 32px;
        }
      }
    }
  }

  &-tag {
    margin-top: 24px;
    width: 1135px;
    display: flex;
    justify-content: center;
    gap: 24px;

    &-item {
      flex: 1;

      &-title {
        font-size: 16px;
        font-weight: 700;
        line-height: 30px;
        height: 54px;
        line-height: 54px;
        color: $grey-black;
        background-color: #c7d3c7;
        text-align: center;
        border-radius: 4px;
      }

      &-desc {
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        color: #656565;
        margin-top: 16px;
      }
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-card {
      width: 100%;
      margin-top: 40px;
      padding: 40px;
    }

    &-tag {
      margin-top: 40px;
      width: 100%;
    }
  }
}
</style>
